import gql from 'graphql-tag';

export default gql`
    mutation AddLoadNotes($input: AddLoadNotesInput) {
        addLoadNotes(input: $input) {
            errors
            loadNotesId
        }
    }
`;
